import { Popover, Select } from 'antd'
import { Horizontal, Vertical, Texto, GraviButton } from '@gravitate-js/excalibrr'
import React, { useState } from 'react'

export const ActionPopover = ({ isVisible, trailerToLeft, cancelChange, addAction, trailerNames }) => {
  const [value, setValue] = useState('')
  return (
    <Popover
      destroyTooltipOnHide={{ keepParent: false }}
      open={isVisible}
      title={
        <>
          <Texto category='h6'>Trailer Swap</Texto>
          <hr className='action-block-hr' />
        </>
      }
      placement='top'
      trigger='contextMenu'
      content={(props) => (
        <div {...props}>
          <Horizontal className='p-2'>
            <Vertical>
              <Texto>FROM:</Texto>
            </Vertical>
            <Vertical>
              <Texto weight='bold' align='right'>
                {trailerToLeft}
              </Texto>
            </Vertical>
          </Horizontal>
          <Horizontal className='p-2'>
            <Vertical>
              <Texto style={{ padding: '5px 0', color: 'var(--theme-color-2)' }}>Changing To:</Texto>
            </Vertical>
            <Vertical alignItems='flex-end'>
              <TrailerConfigSelect
                value={value}
                onChange={(e) => {
                  setValue(e)
                }}
                trailerNames={trailerNames}
                trailerToLeft={trailerToLeft}
              />
            </Vertical>
          </Horizontal>
          <hr className='action-block-hr' />
          <Horizontal style={{ marginTop: '20px', marginRight: 0, marginLeft: 0 }}>
            <Vertical alignItems='flex-start'>
              <GraviButton onClick={cancelChange} style={{ width: '100px' }} buttonText='Cancel' />
            </Vertical>
            <Vertical className='p-2' />
            <Vertical alignItems='flex-end'>
              <GraviButton
                onClick={() => addAction(value)}
                style={{ margin: '0 0 0 25px', width: '100px' }}
                buttonText='Save'
                theme2
              />
            </Vertical>
          </Horizontal>
        </div>
      )}
    />
  )
}
const TrailerConfigSelect = ({ value, onChange, trailerNames, trailerToLeft }) => {
  return (
    <Select value={value} style={{ width: 120, marginRight: 0 }} onChange={onChange}>
      {trailerNames.map((option) => {
        if (option !== trailerToLeft)
          return (
            <Select.Option value={option} key={option.toLowerCase()}>
              {option}
            </Select.Option>
          )
      })}
    </Select>
  )
}
